const SIGNATURE_EXPORT_CONFIG = {
  backgroundColor: 'transparent',
  signatureColor: '#111111',
  mimeType: 'image/png',
  fileName: 'signature.png'
};

export const exportSignatureAsBlackAndWhite = async (
  sourceCanvas: HTMLCanvasElement
): Promise<Blob | null> => {
  const exportCanvas = document.createElement('canvas');
  exportCanvas.width = sourceCanvas.width;
  exportCanvas.height = sourceCanvas.height;
  const canvasCtx = exportCanvas.getContext('2d');

  if (!canvasCtx) {
    return null;
  }

  canvasCtx.drawImage(sourceCanvas, 0, 0);

  canvasCtx.globalCompositeOperation = 'source-in';
  canvasCtx.fillStyle = SIGNATURE_EXPORT_CONFIG.signatureColor;
  canvasCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

  canvasCtx.globalCompositeOperation = 'destination-over';
  canvasCtx.fillStyle = SIGNATURE_EXPORT_CONFIG.backgroundColor;
  canvasCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

  return new Promise<Blob | null>((resolve) => {
    exportCanvas.toBlob(
      (blob) => resolve(blob),
      SIGNATURE_EXPORT_CONFIG.mimeType
    );
  });
};

export const blobToFile = (
  blob: Blob,
  fileName: string = SIGNATURE_EXPORT_CONFIG.fileName
): File => {
  return new File([blob], fileName, {
    type: blob.type || SIGNATURE_EXPORT_CONFIG.mimeType,
    lastModified: Date.now()
  });
};
